import { useTranslation } from 'react-i18next';

import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import { SettingToggleField } from './setting-toggle-field';

type MemorySectionProps = {
  enableSummary: boolean;
  onEnableSummaryChange: (value: boolean) => void;
  lastNConversations: number;
  onLastNConversationsChange: (value: number) => void;
  disabled?: boolean;
};

export function MemorySection({
  enableSummary,
  onEnableSummaryChange,
  lastNConversations,
  onLastNConversationsChange,
  disabled = false,
}: MemorySectionProps) {
  const { t } = useTranslation();

  return (
    <fieldset
      disabled={disabled}
      className="m-0 w-full space-y-6 border-0 p-0 disabled:opacity-70"
    >
      <SettingToggleField
        label={t('SUMMARY') || 'Summary'}
        description={
          t('ENABLE_CONVERSATION_SUMMARY_FOR_CONTEXT') ||
          'Enable conversation summary for better context retention.'
        }
        checked={enableSummary}
        onCheckedChange={onEnableSummaryChange}
        disabled={disabled}
        showInfoIcon
      />

      <div className="space-y-3">
        <Label htmlFor="memory-rounds" className="text-sm font-medium text-foreground">
          {t('ROUNDS') || 'Rounds'}
        </Label>
        <Input
          id="memory-rounds"
          type="number"
          min={1}
          max={20}
          value={lastNConversations}
          disabled={disabled}
          onChange={(event) => {
            const value = parseInt(event.target.value, 10) || 1;
            const clampedValue = Math.min(Math.max(value, 1), 20);
            onLastNConversationsChange(clampedValue);
          }}
          className="h-12 text-lg font-medium"
        />
        <p className="text-sm text-muted-foreground">
          {t('CHAT_ROUNDS_SHORT_TERM_MEMORY_MAX_20') ||
            "The number of chat rounds that become the agent's short-term memory (max 20)."}
        </p>
      </div>
    </fieldset>
  );
}
